import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ResponsiveContext, Button, Layer, TextArea, Anchor, TextInput, Text, Box, Select } from 'grommet';
import { AddCircle, Trash, FormClose } from 'grommet-icons';

import { TitleField, CalendarDropButton, DescriptionField, SelectSearch } from '../../../../components/form';
import { Placeholder, ErrorForm } from '../../../../components';
import { TitleDetail } from '../../../../components/detail';

import { searchServices } from '../../actions/form-search';
import { getVotersOptions } from '../../../../actions/select-options';
import { update, create, changeField, hideFormManagerLayer, addDocument, removeDocument } from '../../actions/form-manager';

import visibleWidth from '../../../../constants/layer-width';

import { formattedDateTime } from '../../../../utils';

class FormCreate extends Component {
  callbackPostSuccess = () => {
    const {
      searchServices,
      hideFormManagerLayer,
    } = this.props;

    searchServices();
    hideFormManagerLayer();
  };

  handlePost = formParams => {
    const { create, update } = this.props;

    if(formParams.id) {
      update({ formParams });
    }
    else {
      create({
        formParams,
        callbackSuccess: this.callbackPostSuccess
      });
    }
  };

  onSearchVoters = text => {
    if (text.length < 2) return;

    const { getVotersOptions } = this.props;
    getVotersOptions({ name: text });
  };

  render() {
    const {
      documentTypeOptions,
      votersOptions,
      usersOptions,
      statusOptions,
      originOptions,
      categoryOptions,
      officeOptions,
      departmentOptions,

      categoryId,
      description,
      documents,
      electorId,
      id,
      officeId,
      originId,
      departmentId,
      requestDate,
      completionDate,
      responsibles,
      statusId,
      voterName,

      getDataFormEditError,
      isEditing,
      toggleLayer,
      loadingPostForm,
      postDataError,

      changeField,
      hideFormManagerLayer,

      addDocument,
      removeDocument,
    } = this.props;


    if(toggleLayer && toggleLayer === 'manager') {
      return (
        <ResponsiveContext.Consumer>
          {size => (
            <Layer
              responsive={false}
              full='vertical'
              position='left'
              onClickOutside={hideFormManagerLayer}
              onEsc={hideFormManagerLayer}
            >
              <Box
                fill='vertical'
                width={visibleWidth[size]}
                pad={{ top: 'large', bottom: 'xsmall' }}
                overflow='auto'
                flex
              >
                {isEditing && !id && !getDataFormEditError ? (
                  <Placeholder
                    title='Carregando...'
                    message='Aguarde que estamos preparando as coisas :)'
                  />
                ) : null}

                {getDataFormEditError ? (
                  <Placeholder
                    title='Ops! Algo deu errado :('
                    message='Estamos constrangidos por isso.'
                    button={{
                      label: 'Fechar',
                      action: hideFormManagerLayer,
                    }}
                  />
                ) : null}

                {!getDataFormEditError && ((isEditing && id) || !isEditing) ? (
                  <>
                    <Box
                      direction='row'
                      justify='between'
                      align='baseline'
                      margin={{ horizontal: 'large' }}
                    >
                      <TitleDetail value={id ? 'Editar atendimento' : 'Novo atendimento'} />

                      <Button
                        plain
                        title='Fechar'
                        icon={<FormClose />}
                        onClick={hideFormManagerLayer}
                      />
                    </Box>


                    <Box flex overflow='auto'>
                      <Box
                        margin={{
                          vertical: 'small',
                          horizontal: 'large'
                        }}
                        flex={{ shrink: 0 }}
                      >
                        <Box direction='row' align='center' gap='xsmall'>
                          <TitleField text='Eleitor do atendimento' required />

                          {electorId && (
                            <Anchor
                              size='small'
                              label='Trocar eleitor'
                              onClick={() => {
                                changeField({ fieldName: 'electorId', value: null }, 'changeFormManagerField');
                                changeField({ fieldName: 'voterName', value: null }, 'changeFormManagerField');
                              }}
                            />
                          )}
                        </Box>

                        <Select
                          searchPlaceholder='Digite o nome do eleitor para buscar...'
                          emptySearchMessage='Nenhum resultado encontrado.'
                          labelKey='name'
                          valueKey={{ key: 'id', reduce: true }}
                          dropHeight='small'
                          closeOnChange
                          options={
                            electorId && voterName ? [{ id: electorId, name: voterName }] : votersOptions
                          }
                          onChange={({ value: nextValue }) =>
                            changeField({ fieldName: 'electorId', value: nextValue }, 'changeFormManagerField')
                          }
                          value={ electorId ?? '' }
                          onSearch={ text => this.onSearchVoters(text) }
                          disabled={ electorId > 0 }
                        >
                          {({ name, telephone, districtName, cityName }) => {
                            return (
                              <Box pad={{ horizontal: 'small', vertical: 'small' }}>
                                <Text size='medium' color='dark-1'>{name}</Text>

                                {
                                  telephone &&
                                    <Text size='xsmall' color='dark-5'>{telephone}</Text>
                                }
                                {
                                  districtName && cityName &&
                                    <Text size='xsmall' color='dark-5'>{districtName}, {cityName}</Text>
                                }
                              </Box>
                            )
                          }}
                        </Select>

                        <ErrorForm errorsList={postDataError.errors} fieldName='electorId' />
                      </Box>

                      <Box
                        border={{ color: 'light-3', side: 'bottom' }}
                        margin={{ top: 'medium', bottom: 'medium' }}
                      />


                      <Box
                        margin={{
                          vertical: 'small',
                          horizontal: 'large'
                        }}
                        flex={{ shrink: 0 }}
                      >
                        <TitleField text='Status' required />

                        <SelectSearch
                          options={statusOptions}
                          value={statusId ?? ''}
                          labelKey='name'
                          valueKey={{ key: 'id', reduce: true }}
                          disabled={isEditing}
                          placeholder='Selecione o status desse atendimento'
                          title={isEditing ? 'Para trocar o status utilize a função que está na listagem de atendimento.' : null}
                          onChange={({ value: nextValue }) =>
                            changeField({ fieldName: 'statusId', value: nextValue }, 'changeFormManagerField')
                          }
                        />

                        <ErrorForm errorsList={postDataError.errors} fieldName='statusId' />
                      </Box>

                      <Box
                        margin={{
                          vertical: 'small',
                          horizontal: 'large'
                        }}
                        direction={ size === 'small' ? 'column' : 'row' }
                        align='stretch'
                        flex={{ shrink: 0 }}
                        gap='small'
                      >
                        <Box
                          width={ size === 'small' ? '100vw' : '50vw'}
                          gap='xxsmall'
                        >
                          <TitleField
                            text='Data solicitação' required
                          />

                          <DescriptionField
                            text='Data que o atendimento foi solicitado pelo eleitor.'
                          />
                        </Box>

                        <Box
                          width={ size === 'small' ? '100vw' : '50vw'}
                        >
                          <CalendarDropButton
                            date={requestDate ?? ''}
                            onSelect={(selectedDate) => changeField({ fieldName: 'requestDate', value: selectedDate }, 'changeFormManagerField')}
                          />

                          <ErrorForm errorsList={postDataError.errors} fieldName='requestDate' />
                        </Box>
                      </Box>

                      <Box
                        margin={{
                          vertical: 'small',
                          horizontal: 'large'
                        }}
                        direction={ size === 'small' ? 'column' : 'row' }
                        align='stretch'
                        flex={{ shrink: 0 }}
                        gap='small'
                      >
                        <Box
                          width={ size === 'small' ? '100vw' : '50vw'}
                          gap='xxsmall'
                        >
                          <TitleField
                            text='Data conclusão'
                          />

                          <DescriptionField
                            text='Data que o atendimento foi finalizado.'
                          />
                        </Box>

                        <Box
                          width={ size === 'small' ? '100vw' : '50vw'}
                        >
                          <CalendarDropButton
                            date={completionDate ?? ''}
                            onSelect={
                              (selectedDate) => changeField({ fieldName: 'completionDate', value: selectedDate }, 'changeFormManagerField')
                            }
                          />

                          <ErrorForm errorsList={postDataError.errors} fieldName='completionDate' />
                        </Box>
                      </Box>


                      <Box
                        border={{ color: 'light-3', side: 'bottom' }}
                        margin={{ top: 'medium', bottom: 'medium' }}
                      />


                      {/* Secretaria */}
                      <Box
                        margin={{
                          vertical: 'small',
                          horizontal: 'large'
                        }}
                        flex={{ shrink: 0 }}
                      >
                        <Box direction='row' align='center' gap='xsmall'>
                          <TitleField text='Secretaria' />

                          {departmentId && (
                            <Anchor
                              size='small'
                              label='limpar'
                              onClick={() =>
                                changeField({ fieldName: 'departmentId', value: null }, 'changeFormManagerField')
                              }
                            />
                          )}
                        </Box>

                        <SelectSearch
                          options={departmentOptions}
                          value={departmentId ?? ''}
                          labelKey='name'
                          valueKey={{ key: 'id', reduce: true }}
                          placeholder='Selecione qual a área de interesse'
                          onChange={({ value: nextValue }) =>
                            changeField({ fieldName: 'departmentId', value: nextValue }, 'changeFormManagerField')
                          }
                        />

                        <ErrorForm errorsList={postDataError.errors} fieldName='departmentId' />
                      </Box>

                      {/* Origem */}
                      <Box
                        margin={{
                          vertical: 'small',
                          horizontal: 'large'
                        }}
                        flex={{ shrink: 0 }}
                      >
                        <TitleField text='Origem' required />

                        <SelectSearch
                          options={originOptions}
                          value={originId ?? ''}
                          labelKey='name'
                          valueKey={{ key: 'id', reduce: true }}
                          placeholder='Por qual canal o atendimento chegou?'
                          onChange={({ value: nextValue }) =>
                            changeField({ fieldName: 'originId', value: nextValue }, 'changeFormManagerField')
                          }
                        />

                        <ErrorForm errorsList={postDataError.errors} fieldName='originId' />
                      </Box>

                      {/* Escritório e Categoria */}
                      <Box
                        margin={{
                          vertical: 'small',
                          horizontal: 'large'
                        }}
                        flex={{ shrink: 0 }}
                      >
                        <Box direction='row' gap='small'>
                          <Box width='50vw'>
                            <TitleField text='Escritório' required />

                            <SelectSearch
                              options={officeOptions}
                              value={officeId ?? ''}
                              labelKey='name'
                              valueKey={{ key: 'id', reduce: true }}
                              placeholder='Em qual escritório o eleitor foi atendido?'
                              title='Em qual escritório o eleitor foi atendido?'
                              onChange={({ value: nextValue }) =>
                                changeField({ fieldName: 'officeId', value: nextValue }, 'changeFormManagerField')
                              }
                            />

                            <ErrorForm errorsList={postDataError.errors} fieldName='officeId' />
                          </Box>

                          <Box width='50vw'>
                            <TitleField text='Categoria' required />

                            <SelectSearch
                              options={categoryOptions}
                              value={categoryId ?? ''}
                              labelKey='name'
                              valueKey={{ key: 'id', reduce: true }}
                              placeholder='Qual a categoria do atendimento?'
                              title='Selecione a categoria do atendimento?'
                              onChange={({ value: nextValue }) =>
                                changeField({ fieldName: 'categoryId', value: nextValue }, 'changeFormManagerField')
                              }
                            />

                            <ErrorForm errorsList={postDataError.errors} fieldName='categoryId' />
                          </Box>
                        </Box>
                      </Box>


                      <Box
                        border={{ color: 'light-3', side: 'bottom' }}
                        margin={{ top: 'medium', bottom: 'medium' }}
                      />

                      <Box
                        margin={{
                          vertical: 'small',
                          horizontal: 'large'
                        }}
                        flex={{ shrink: 0 }}
                        direction={ size === 'small' ? 'column' : 'row' }
                        align='stretch'
                        gap='small'
                      >
                        <Box
                          width={ size === 'small' ? '100vw' : '40vw'}
                          gap='xxsmall'
                        >
                          <TitleField text='Responsáveis' />

                          <DescriptionField
                            text='Usuários responsáveis por acompanhar o atendimento.'
                          />
                        </Box>

                        <Box
                          width={ size === 'small' ? '100vw' : '60vw'}
                        >
                          <Select
                            options={
                              usersOptions.filter(
                                a => a.status || (responsibles && responsibles.some(userId => userId === a.id))
                              )
                            }
                            value={responsibles ?? ''}
                            labelKey='name'
                            valueKey={{ key: 'id', reduce: true }}
                            multiple
                            closeOnChange={false}
                            onChange={({ value: nextValue }) =>
                              changeField({ fieldName: 'responsibles', value: nextValue }, 'changeFormManagerField')
                            }
                            placeholder='Selecione quem irá acompanhar esse atendimento'
                            valueLabel={
                              responsibles && responsibles.length > 1 ? (
                                <Box pad='small'>
                                  <Text>{`${responsibles.length} selecionado(s)`}</Text>
                                </Box>
                              ) : null
                            }
                          />
                        </Box>
                      </Box>


                      <Box
                        border={{ color: 'light-3', side: 'bottom' }}
                        margin={{ top: 'medium', bottom: 'medium' }}
                      />


                      <Box
                        margin={{
                          vertical: 'small',
                          horizontal: 'large'
                        }}
                        flex={{ shrink: 0 }}
                      >
                        <TitleField text='Descrição' required />

                        <TextArea
                          rows={5}
                          resize='vertical'
                          maxLength={1000}
                          value={description ?? ''}
                          placeholder='Coloque aqui todos os detalhes que o eleitor informou.'
                          onChange={event =>
                            changeField({ fieldName: 'description', value: event.target.value }, 'changeFormManagerField')
                          }
                        />

                        <ErrorForm errorsList={postDataError.errors} fieldName='description' />
                      </Box>

                      <Box
                        border={{ color: 'light-3', side: 'bottom' }}
                        margin={{ top: 'medium', bottom: 'medium' }}
                      />

                      <Box
                        margin={{ horizontal: 'large', bottom: 'small' }}
                        flex={{ shrink: 0 }}
                        direction='row'
                        justify='between'
                        align='center'
                      >
                        <Text size='medium' color='dark-2'>
                          Ofícios, moções, indicações, gerados por esse atendimento
                        </Text>

                        <Anchor
                          icon={<AddCircle size='medium' />}
                          title='Adicionar documento'
                          onClick={() => addDocument({
                              number: null,
                              typeId: null,
                              year: null,
                            })
                          }
                        />
                      </Box>

                      {documents && documents.map((item, index) => {
                        return (
                          <Box
                            key={index}
                            margin={{
                              vertical: 'small',
                              horizontal: 'large'
                            }}
                            flex={{ shrink: 0 }}
                          >
                            <Box direction='row' align='center' gap='small'>
                              <Box>
                                <TitleField text='Tipo' required />

                                <Select
                                  options={documentTypeOptions}
                                  value={item.typeId ?? ''}
                                  labelKey='name'
                                  valueKey={{ key: 'id', reduce: true }}
                                  placeholder='Selecione o tipo do documento'
                                  onChange={({ value: nextValue }) =>
                                    changeField({ value: nextValue, item: 'typeId', index }, 'changeFormManagerDocument')
                                  }
                                />
                              </Box>

                              <Box>
                                <TitleField text='Número' required />

                                <TextInput
                                  type='number'
                                  value={item.number ?? ''}
                                  onChange={event => changeField({ value: event.target.value, item: 'number', index }, 'changeFormManagerDocument')}
                                />
                              </Box>

                              <Box margin={{ right: 'xsmall' }}>
                                <TitleField text='Ano' required />

                                <TextInput
                                  type='number'
                                  value={item.year ?? ''}
                                  onChange={event => changeField({ value: event.target.value, item: 'year', index }, 'changeFormManagerDocument')}
                                />
                              </Box>

                              <Anchor
                                icon={<Trash />}
                                color='status-error'
                                title='Remover'
                                onClick={() =>
                                  removeDocument(item)
                                }
                              />
                            </Box>
                          </Box>
                        )
                      })}

                      {postDataError.errors && postDataError.errors.length > 0 && (
                        <Box
                          margin={{
                            vertical: 'small',
                            horizontal: 'large'
                          }}
                          flex={{ shrink: 0 }}
                        >
                          <ErrorForm errorsList={postDataError.errors} fieldName='documents.all' />
                        </Box>
                      )}
                    </Box>


                    <Box
                      direction='row'
                      pad={{ vertical: 'medium' }}
                      justify='center'
                      align='center'
                      gap='small'
                    >
                      <Box width='xsmall'>
                        <Anchor
                          color='dark-3'
                          label='Cancelar'
                          disabled={ loadingPostForm }
                          onClick={hideFormManagerLayer}
                        />
                      </Box>

                      <Box width='small'>
                        <Button
                          color='brand'
                          primary
                          label={ !loadingPostForm ? 'Salvar': 'Salvando...' }
                          disabled={ loadingPostForm }
                          onClick={() =>
                            this.handlePost({
                              categoryId,
                              description,
                              documents,
                              electorId,
                              id,
                              officeId,
                              originId,
                              departmentId,
                              requestDate: formattedDateTime(requestDate),
                              completionDate: formattedDateTime(completionDate),
                              responsibles,
                              statusId,
                            })
                          }
                        />
                      </Box>
                    </Box>
                  </>
                ) : null}
              </Box>
            </Layer>
          )}
        </ResponsiveContext.Consumer>
      )
    }

    return null;
  }
}

const mapStateToProps = ({
  servicesReducer: { formManager },
  layerReducer,
  selectOptionsReducer,
}) => ({
  documentTypeOptions: selectOptionsReducer.documentTypeOptions,
  votersOptions: selectOptionsReducer.votersOptions,
  usersOptions: selectOptionsReducer.usersOptions,
  statusOptions: selectOptionsReducer.statusServiceOptions,
  originOptions: selectOptionsReducer.originServiceOptions,
  categoryOptions: selectOptionsReducer.categoryServiceOptions,
  officeOptions: selectOptionsReducer.officeOptions,
  departmentOptions: selectOptionsReducer.departmentOptions,

  categoryId: formManager.categoryId,
  description: formManager.description,
  documents: formManager.documents,

  id: formManager.id,
  officeId: formManager.officeId,
  originId: formManager.originId,
  departmentId: formManager.departmentId,
  requestDate: formManager.requestDate,
  completionDate: formManager.completionDate,
  responsibles: formManager.responsibles,
  statusId: formManager.statusId,

  electorId: formManager.electorId,
  voterName: formManager.voterName,

  getDataFormEditError: formManager.getDataFormEditError,
  isEditing: formManager.isEditing,
  loadingPostForm: formManager.loadingPostForm,
  postDataError: formManager.postDataError,

  toggleLayer: layerReducer.toggleLayer,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    getVotersOptions,
    update,
    create,
    changeField,
    searchServices,
    hideFormManagerLayer,
    addDocument,
    removeDocument,
  }, dispatch);

export const Create = connect(mapStateToProps, mapDispatchToProps)(FormCreate);
